import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface MaxCountMonthProps {
  isShow: boolean;
  countMonth: number;
}

const MaxCountMonth: FC<MaxCountMonthProps> = ({ isShow, countMonth }) => {
  const { t } = useTranslation();
  return (
    <>
      {isShow ? (
        <div className="payment__content__options__number-of-month-selector__header">
          <div className="payment__content__options__number-of-month-selector__header__amount">
            <article className="payment__content__label">
              {t('servicePayment.numberMonths')}{' '}
              {`(${t('servicePayment.maxNumberMonths', {
                val: countMonth,
              })})`}
            </article>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default MaxCountMonth;
